import { render, staticRenderFns } from "./qualitytestgoods.vue?vue&type=template&id=d1a81308&scoped=true&"
import script from "./qualitytestgoods.vue?vue&type=script&lang=js&"
export * from "./qualitytestgoods.vue?vue&type=script&lang=js&"
import style0 from "./qualitytestgoods.vue?vue&type=style&index=0&id=d1a81308&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a81308",
  null
  
)

export default component.exports